import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'

import { selectSortedCompaniesOptions } from 'containers/App/selectors'
import { companyFilterChange } from 'containers/PartnerOptions/actions'
import { selectPsimaCompanyIds } from 'containers/SpearPhishingAgent/selectors'

import Combobox from 'components/lib/DesignSystem/V3/Combobox'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding: 120px 16px;
`

const Title = styled.div`
  font: var(--t-typography-heading-1);
  color: var(--color-text);
  text-align: center;
`

const Description = styled.div`
  font-size: var(--t-typography-font-size-xs);
  line-height: var(--t-typography-line-height-xs);
  color: var(--sub-text-color);
  text-align: center;
  max-width: 460px;
`

const Field = styled.div`
  width: 280px;
`

// Mirrors the campaign wizard's PartnerCompanyStep: a partner has nothing to look at until
// they pick a client, so the page asks once instead of showing an empty dashboard for the
// partner's own company. Only clients whose PSIMA is licensed and billed are offered.
const ChooseCompanyGate = () => {
  const dispatch = useDispatch()
  const companies = useSelector(selectSortedCompaniesOptions)
  const psimaCompanyIds = useSelector(selectPsimaCompanyIds)

  const options = companies.filter((company) => psimaCompanyIds.includes(company.value))

  return (
    <Container data-testid="Psima_ChooseCompanyGate_div">
      <Title>Choose one of your companies</Title>
      <Description>
        {/* One empty answer, not two. The list is emptied by licensing or billing, both of
            which go through a CSM. It is no longer emptied by permissions -- a client the
            user cannot run simulations for is still offered, and picking it explains why. */}
        {options.length
          ? 'Phishing Simulation Agent runs per company. Pick the one you want to work on.'
          : 'None of your companies have Phishing Simulation Agent available yet. Contact your Customer Success Manager to add it to a plan.'}
      </Description>
      {options.length > 0 && (
        <Field>
          <Combobox
            id="Psima_ChooseCompanyGate_Select"
            dataTestId="Psima_ChooseCompanyGate_Select"
            placeholder="Select company"
            options={options}
            fullWidth
            onChange={(value) => {
              const picked = options.find((company) => company.value === value)
              if (picked) {
                dispatch(companyFilterChange({ value: picked.value, label: picked.label }))
              }
            }}
          />
        </Field>
      )}
    </Container>
  )
}

export default ChooseCompanyGate
